import * as api from '@/http'

export const ActionSetEmployees = async ({ commit }, departmentId) => {
  const employees = await api.http
    .get(`dash/coordinator/employees/${departmentId}`)
    .then((response) => response.body)
  commit('SET_employees', employees)
}

export const ActionSetBirthdays = async ({ commit }) => {
  const birthdays = await api.http.get('dash/employees/birthdays').then((response) => response.body)
  commit('SET_birthdays', birthdays)
}
